'use strict';

const isCSSVar = (name) => name.startsWith("--");

exports.isCSSVar = isCSSVar;
//# sourceMappingURL=is-css-var.cjs.map
